/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_freeGlobal.js
// module id = 659
// module chunks = 0 1 2 3 4 5 6 7 8